/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const AlertCircle = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 19 19" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M9.5 0A9.5 9.5 0 1 0 19 9.5 9.51 9.51 0 0 0 9.5 0zm0 15a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 9.53 15zM11 9.5a1.5 1.5 0 0 1-3 0v-4a1.5 1.5 0 0 1 3 0z" fillRule="evenodd" />
      </g>
    </svg>
  </span>
);

AlertCircle.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

AlertCircle.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default AlertCircle;
